import { Component, OnInit, HostListener } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ReportingService } from '../services/reporting.service';
import { saveAs } from 'file-saver/FileSaver';
declare var $ : any;

@Component({
  selector: 'app-testsummary',
  templateUrl: './testsummary.component.html',
  styleUrls: ['./testsummary.component.css']
})
export class TestSummaryComponent implements OnInit {

  Tests = [];
  datePattern = /^\d{2}\/\d{2}\/\d{4}$/;
  dateReg = new RegExp(/^\d{2}\/\d{2}\/\d{4}$/);
  isValid = true;

  constructor(private reportService: ReportingService, private router : Router) {
      
      this.GetTestList();
  }

  ngOnInit() {
    this.SetupDatePickers();
  }

  GetTestList(){   
    let t = sessionStorage.getItem('testList');
     
    if (t != null && t.length > 0)
    {
      this.Tests = JSON.parse(t);
      return;
    }
    else
    {
      this.reportService.getTestList().subscribe(
        (data : any)=>{
          this.Tests = data;
          sessionStorage.setItem('testList', JSON.stringify(data));
        },
        (err : HttpErrorResponse)=>{
          console.log(err);
        }
      );
    }
  }

  SetupDatePickers(){
    var form = this;
    var myDate = new Date();
    myDate.setMonth(myDate.getMonth() - 1);

    $('#FromDate').datepicker({
      dateFormat: "mm/dd/yyyy",
      weekStart: 0,
      daysOfWeekHighlighted: "6,0",
      autoclose: true,
      todayBtn: true,
      todayHighlight: true,
      startDate:"-5y",
      endDate: "+0d"
    }).datepicker("setDate", myDate.toLocaleDateString("en-US"));

    $("#FromDate").change(function(){
      $(document).ready(()=>{
        form.isValid = form.Validate();
        console.log(form.isValid);
      });
    });

    $('#ToDate').datepicker({
      dateFormat: "mm/dd/yyyy",
      weekStart: 0,
      daysOfWeekHighlighted: "6,0",
      autoclose: true,
      todayBtn: true,
      todayHighlight: true,
      startDate:"-5y",
      endDate: "+0d"
    }).datepicker("setDate", new Date().toLocaleDateString("en-US"));
    
    $("#ToDate").change(function(){
        $(document).ready(()=>{
        form.isValid = form.Validate();
        console.log(form.isValid);
      });
    });
  }
  
  OnSubmit(fromDate, toDate, catalogNumber)
  {
   
    let sortBy = $('input[name=sortBy]:checked').val();
    console.log("SortBy",sortBy);
    this.reportService.getSummaryReport(fromDate, toDate, catalogNumber, sortBy).subscribe(
      (data : any)=>{
        let url = window.URL.createObjectURL(data);
        // let fileName = url.substring(url.lastIndexOf('/')+1)+".pdf";
        window.URL.revokeObjectURL(url);
        var blob = new Blob([data], {type: 'application/pdf'});
        saveAs(blob, "TestSummary.pdf");
      },
      (err : HttpErrorResponse)=>{
        console.log(err);
      }
    );
  }

  Validate() : boolean
  {
    var options = {year:'numeric',month:'2-digit',day:'2-digit'};
    try
    {
      let fromDate = $("#FromDate").val();
      let toDate = $("#ToDate").val();

      if (fromDate.length==0 || toDate.length==0) return false;

      if (!this.dateReg.test($("#FromDate").val()))
        return false;
        
      if (!this.dateReg.test($("#ToDate").val()))
        return false;
      
      var fd = new Date(fromDate);
      var td = new Date(toDate);
      if (fd.valueOf() > td.valueOf())
      {
        console.log("backwards");
        $("#FromDate").val(td.toLocaleDateString("en-US", options));
      }
      return true;
    }
    catch(e)
    {
      return false;
    }
  }
}
   